import { Link } from "@inertiajs/react"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MarketingMetadata } from "@/components/marketing/MarketingMetadata"
import type { MarketingPageProps } from "@/types/marketing"

export default function MarketingContactThankYou(props: MarketingPageProps) {
  const requested = props.consultation_requested_start
  const copy = props.locale === "hr" ? {
    requested: "Zatraženi termin",
    missing: "Zatraženi termin nalazi se u e-poruci koju smo vam poslali.",
    next: "Što slijedi",
    nextBody: "Antonio će provjeriti raspoloživost. Termin vrijedi tek nakon zasebne potvrdne e-poruke; ako nije dostupan, predložit ćemo drugo vrijeme.",
    before: "Dok čekate",
    beforeBody: "Pogledajte kako smo povezali VanCleef ili Čajanku.",
    contact: "Ako se ne javimo, pišite na",
  } : {
    requested: "Requested time",
    missing: "Your requested time is included in the email we sent you.",
    next: "What happens next",
    nextBody: "Antonio will check availability. The time becomes valid only after a separate confirmation email; if unavailable, we’ll suggest another time.",
    before: "While you wait",
    beforeBody: "See how we connected the work at VanCleef or Čajanka.",
    contact: "If you do not hear from us, email",
  }

  return (
    <>
      <MarketingMetadata alternateUrls={props.alternate_urls} canonicalUrl={props.canonical_url} description={props.description} locale={props.locale} noindex socialImageUrl={props.social_image_url} title={props.title} />
      <MarketingLayout consultationHref={props.consultation_href} currentPageKey={props.page_key} footer={props.footer} homeHref={props.home_href} languageSwitch={props.language_switch} locale={props.locale} navigation={props.navigation}>
        <section className="booking-confirmation">
          <h1 className="type-marketing-hero-display">{props.heading}</h1>
          <p className="type-marketing-lead">{props.summary}</p>
          <div className="booking-confirmation-grid">
            <div>
              <strong>{copy.requested}</strong>
              {requested ? <p><time dateTime={requested.iso}>{requested.formatted}</time><br /><span className="type-marketing-caption">{requested.timezone} · 30 min</span></p> : <p>{copy.missing}</p>}
            </div>
            <div><strong>{copy.next}</strong><p>{copy.nextBody}</p></div>
            <div><strong>{copy.before}</strong><p>{copy.beforeBody}</p><p><Link href={props.vancleef_href}>VanCleef →</Link> · <Link href={props.cajanka_href}>Čajanka →</Link></p></div>
          </div>
          <p>{copy.contact} <a href="mailto:info@zmile.hr">info@zmile.hr</a>.</p>
        </section>
      </MarketingLayout>
    </>
  )
}
